(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-race', {
                parent: 'entity',
                url: '/type-race',
                data: {
                    authorities: [],
                    pageTitle: 'TypeRaces'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-race/list/type-race.html',
                        controller: 'TypeRaceController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Race Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE, access);
                }]
            });
    }
})();
